import { fetcher } from '@/src/general/utilities/fetcher'
import type { TSignalConfig } from '@/src/general/utilities/fetcher/IFetcher'

import type { TAvatarSaintPayload } from './types/avatarSaints.types'
import type { TEditAccountSettingsData, TEditAccountSettingsPayload } from './types/editAccountSettings.types'

export const settingsApi = {
  editAccountSettings: (payload: TEditAccountSettingsPayload) =>
    fetcher.mutate<TEditAccountSettingsData, TEditAccountSettingsPayload>('/me/settings', payload, {
      method: 'PATCH',
    }),
  clearMailDeliveryIssues: () => fetcher.mutate<void>('/me/mail-delivery-issues/clear', {}, { method: 'POST' }),
  unsubscribePresubscriber: (email: string) => fetcher.mutate<void>(`/presubscriber`, { email }, { method: 'DELETE' }),
  getSaintsAvatar: ({ signal }: TSignalConfig) => fetcher.query<TAvatarSaintPayload[]>('/avatars', { signal }),
}
